<template>
    <form>
        <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="selected1">Metodo</label>
                <select class="form-control custom-select" id="selected1" v-model="form.selected">
                    <option v-for="(fData, f_i) in forms" v-bind:key="'fi'+f_i" :value="f_i">{{fData.name}}</option>
                </select>
            </div>
        </div>

        <template v-if="formData != null">
            <div class="form-group basic" v-for="(elm, e_i) in formData.elements" v-bind:key="'e_i'+e_i">
                <div class="input-wrapper">
                    <label class="label" for="selected1">{{ elm.label }}</label>
                    <template v-if="elm.type == 'text'">
                        <input 
                            type="text"
                            class="form-control"
                            required
                        />
                    </template>
                    <template v-else-if="elm.type == 'number'">
                        <input 
                            type="number"
                            class="form-control"
                            required
                        />
                    </template>
                    <template v-else-if="elm.type == 'select'">
                        <select class="form-control custom-select">
                            <option v-for="(option, option_i) in elm.options" v-bind:key="'option_i'+option_i" :value="option.value">{{option.text}}</option>
                        </select>
                    </template>
                    <template v-else>
                        {{ elm }}
                    </template>
                </div>
            </div>
        </template>

        <div class="form-group basic">
            <button type="button" class="btn btn-primary btn-block btn-lg" data-bs-dismiss="modal">Depositar</button>
        </div>

    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
      form: {
        selected: 0,
      },
      forms: [
        {
            name: 'Bancolombia',
            elements: [
                {
                    name: 'fullname',
                    label: 'Nombre del titular (completo)',
                    type: 'text',
                },
                {
                    name: 'nroidentify',
                    label: '# Identificacion',
                    type: 'text',
                },
                {
                    name: 'account_type',
                    label: 'Tipo de cuenta',
                    type: 'select',
                    options: [
                        {
                            text: 'Cuenta de ahorros',
                            value: 'ahorros',
                        },
                        {
                            text: 'Cuenta coriente',
                            value: 'corriente',
                        },
                    ]
                },
                {
                    name: 'account',
                    label: 'Numero de la cuenta',
                    type: 'number',
                },
            ],
        },
        {
            name: 'Nequi',
            elements: [
                {
                    name: 'fullname',
                    label: 'Nombre del titular (completo)',
                    type: 'text',
                },
                {
                    name: 'nroidentify',
                    label: '# Identificacion',
                    type: 'text',
                },
                {
                    name: 'account',
                    label: 'Numero de la cuenta',
                    type: 'number',
                },
            ],
        },
      ]
    };
  },
  matches: {
  },
  computed: {
    ...mapState(['userData', 'balance', 'last']),
    formData() {
        return this.forms[this.form.selected] ?? null;
    },
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
  },
  methods: {
    ...mapActions(['logoutAPI']),
  }
}
</script>